import {css} from 'styled-components';

/**
 * The helper return scroll styles
 * @return {css}
 */
export default function scrollStyles() {
  return css`
    &::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }

    &::-webkit-scrollbar-button:start:decrement,
    &::-webkit-scrollbar-button:end:increment {
      display: none;
    }

    &::-webkit-scrollbar-track-piece {
      display: none;
      background-color: #232323;
      -webkit-border-radius: 5px;
    }

    &::-webkit-scrollbar-thumb:vertical {
      background-color: #515151;
      border: 5px solid transparent;
      -webkit-border-radius: 100px;
    }
  `;
}
